import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import { CollectionType } from '@/enums/collection-type';
import { calculateUrl } from '@/helpers/state-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import BasicButton from '@/ui-components/BasicButton.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import { useConstantStore } from '@/stores/pinia/useConstantStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'JWTVEndCard',
  setup(__props) {

const router = useRouter();

const constantStore = useConstantStore();

const backgroundUrl = `url(/${ASSETS_DIR}/img/home/bg-tiles/bg-tiles.png)`;

const popularLink = computed(() => {
	return calculateUrl(
		router,
		undefined,
		CollectionType.POPULAR,
		{
			providers: ['jwt'],
		},
		constantStore.providersByShortName
	);
});

function trackButtonClick() {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'click',
		property: 'jwtv-end-card',
		label: 'popular-button',
	});
}

return { __sfc: true,router, constantStore, backgroundUrl, popularLink, trackButtonClick, BasicButton, ProviderIcon }
}

})